import { omit } from 'lodash';
import { SHOW_MODAL } from '../../actions/show-modal';
import { HIDE_MODAL } from '../../actions/hide-modal';
import { WIX_MODAL_CLOSED } from '../../actions/load-and-persist-wix-modal';

const initialState = {};
export default function modalById(state = initialState, action) {
  switch (action.type) {
    case SHOW_MODAL: {
      const { type } = action.payload;
      if (state[type]) {
        return state;
      }

      return {
        ...state,
        [type]: { ...action.payload, meta: action.meta || {} },
      };
    }
    case HIDE_MODAL: {
      return omit(state, action.payload.type);
    }
    case WIX_MODAL_CLOSED: {
      return initialState;
    }
    default:
      return state;
  }
}
